import React, { Component } from "react";
import { connect } from "react-redux";
import { Doughnut } from "react-chartjs-2";
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from "chart.js";

import SideBarNew from "../../SideBarNew";
import TopBarNew from "../../TopBarNew";
import MenuIcon from "../../icons/MenuIcon.svg";
import TowerIcon2 from "../../icons/TowerIcon2.svg";
import { activesubscription } from "../../redux";
import LoaderComponent from "../../ReusableComponents/LoaderComponent";

ChartJS.register(ArcElement, Tooltip, Legend);

const ClockIcon = ({ color = "#000" }) => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M12 6V12L16 14"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

class AllSeverities extends Component {
  state = {
    user: {},
    sidebarMode: "shrunk",
    showBackIcon: true,
    severities: null,
    loading: false,
  };

  componentWillMount() {
    if (this.props.location.state) {
      const { user, sidebarMode, severity, sevarityFormatted } =
        this.props.location.state;
      this.setState({
        user,
        sidebarMode,
        severities: sevarityFormatted,
        rawSeverityData: severity,
        loading: false,
      });
    }
  }

  render() {
    const {
      user,
      sidebarMode,
      showBackIcon,
      severities,
      rawSeverityData,
      loading,
    } = this.state;

    let sidebarConfigurations = {
      options:
        showBackIcon === true
          ? [
              { icon: MenuIcon, text: "Home", path: "/picstork/dashboard" },
              { icon: TowerIcon2, text: "Projects", path: "/picstork/towers" },
            ]
          : null,
      user,
      type: user.type,
      mode: sidebarMode,
      picStorkHelp: true,
    };

    let topbarConfigurations = {
      options:
        showBackIcon === true
          ? [{ icon: MenuIcon, text: "Dashboard", path: "/picstork/dashboard" },
            { icon: MenuIcon, text: "Defect Severity Breakdown", path: "/picstork/allseverities" }
          ]
          : null,
      user,
      type: user.type,
      mode: sidebarMode,
      picStorkHelp: true,
    };

    const severityMap = {
      1: "Low",
      2: "Medium",
      3: "High",
    };

    const severityConfig = {
      High: { color: "#E73F76", background: "#FEF0F5" },
      Medium: { color: "#01B574", background: "#E6F8F1" },
      Low: { color: "#322FC8", background: "#F0EFFF" },
    };

    let groupedDataForColumns = {};

    if (rawSeverityData?.detections) {
      rawSeverityData.detections.forEach((det) => {
        Object.entries(det.severityCounts).forEach(([sevLevel, count]) => {
          if (count > 0 && severityMap[sevLevel]) {
            const sevName = severityMap[sevLevel];
            if (!groupedDataForColumns[sevName]) {
              groupedDataForColumns[sevName] = [];
            }
            groupedDataForColumns[sevName].push({
              name: det.detectionType,
              count: count,
            });
          }
        });
      });
    }

    const orderedSeverities = ["High", "Medium", "Low"];
    const colorMap = {
      Low: "#322fc8",
      Medium: "#01b574",
      High: "#e73f76",
    };

    const doughnutData = {
      labels: orderedSeverities,
      datasets: [
        {
          data: orderedSeverities.map(
            (sev) =>
              severities.datasets[0].data[severities.labels.indexOf(sev)] || 0
          ),
          backgroundColor: orderedSeverities.map((sev) => colorMap[sev]),
        },
      ],
    };

    return user.username ? (
      <div className="wrapper" style={{ backgroundColor: "#F7F8FC" }}>
        <SideBarNew
          config={sidebarConfigurations}
          showMainDashboardIcons={showBackIcon}
        />
        <div className="right-content">
          <TopBarNew config={topbarConfigurations} />

          <div
            className="main-content"
            style={{
              background: "none",
              display: "flex",
              flexDirection: "column",
              marginTop: "20px",
            }}
          >
            <div
              style={{
                marginBottom: "20px",
                fontSize: "1.1rem",
              }}
            >
              Defect Severity Breakdown Details
            </div>
            <div
              style={{
                display: "flex",
                gap: "30px",
                padding: "20px",
                background: "#fff",
                borderRadius: "10px",
                boxShadow: "0px 4px 12px rgba(0,0,0,0.05)",
                height: "calc(100vh - 150px)",
              }}
            >
              <div
                style={{
                  flex: "0 0 300px",
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  paddingTop: "20px",
                }}
              >
                {loading ? (
                  <LoaderComponent />
                ) : severities ? (
                  <>
                    <div style={{ width: "100%", height: "150px" }}>
                      <Doughnut
                        data={doughnutData}
                        options={{
                          cutout: "70%",
                          plugins: { legend: { display: false } },
                          maintainAspectRatio: false,
                          circumference: 180,
                          rotation: -90,
                        }}
                      />
                    </div>

                    <div
                      style={{
                        display: "flex",
                        justifyContent: "space-around",
                        marginTop: "20px",
                        width: "100%",
                      }}
                    >
                      {orderedSeverities.map((severityName) => {
                        const index = severities.labels.indexOf(severityName);
                        if (index === -1) return null;
                        const count = severities.datasets[0].data[index];

                        return (
                          <div
                            key={severityName}
                            style={{
                              display: "flex",
                              flexDirection: "column",
                              alignItems: "center",
                              textAlign: "center",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "6px",
                                fontSize: "1rem",
                              }}
                            >
                              <span
                                style={{
                                  width: "12px",
                                  height: "12px",
                                  borderRadius: "50%",
                                  background: colorMap[severityName],
                                  display: "inline-block",
                                }}
                              />
                              <span>{severityName}</span>
                            </div>
                            <div style={{ marginTop: "5px" }}>{count}</div>
                          </div>
                        );
                      })}
                    </div>
                  </>
                ) : (
                  <div>No data</div>
                )}
              </div>

              <div
                style={{
                  flex: "1",
                  display: "flex",
                  gap: "20px",
                  overflow: "hidden",
                  height: "100%",
                }}
              >
                {orderedSeverities.map((severityName) => (
                  <div
                    key={severityName}
                    style={{
                      flex: 1,
                      display: "flex",
                      flexDirection: "column",
                      border: "1px solid #EAEAEA",
                      borderRadius: "12px",
                      padding: "15px",
                      backgroundColor: "#FFFFFF",
                      justifyContent: "center",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "10px",
                        marginBottom: "20px",
                      }}
                    >
                      <ClockIcon
                        color={severityConfig[severityName]?.color || "#000"}
                      />
                      <span style={{ fontSize: "1.1rem" }}>{severityName}</span>
                    </div>

                    <div
                      style={{
                        overflowY: "auto",
                        flex: 1,
                        paddingRight: "10px",
                      }}
                    >
                      {(groupedDataForColumns[severityName] || []).map(
                        (item, index) => (
                          <div
                            key={index}
                            style={{
                              display: "flex",
                              alignItems: "flex-start",
                              flexDirection: "column",
                              justifyContent: "space-between",
                              padding: "5px",
                              borderRadius: "8px",
                              marginBottom: "5px",
                            }}
                          >
                            <div
                              style={{
                                display: "flex",
                                alignItems: "center",
                                gap: "10px",
                              }}
                            >
                              <span
                                style={{
                                  width: "10px",
                                  height: "10px",
                                  borderRadius: "50%",
                                  backgroundColor:
                                    severityConfig[severityName]?.color ||
                                    "#000",
                                }}
                              />
                              <span style={{ fontSize: "0.9rem" }}>
                                {item.name}
                              </span>
                            </div>
                            <span
                              style={{
                                fontSize: "0.9rem",
                                color: "#555",
                                paddingLeft: "20px",
                              }}
                            >
                              {item.count} Detections
                            </span>
                          </div>
                        )
                      )}
                      {!(groupedDataForColumns[severityName] || []).length && (
                        <div
                          style={{
                            textAlign: "center",
                            color: "#999",
                            marginTop: "20px",
                          }}
                        >
                          No detections
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    ) : (
      <div />
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  activesubscription: (payload) => dispatch(activesubscription(payload)),
});

export default connect(null, mapDispatchToProps)(AllSeverities);